import React, { Component } from 'react';
import './index.less';
import Mobile from '../H5';
import Computer from '../Pc';
class DashBoard extends Component {
  constructor() {
    super();
  }
  render() {
    if (window.innerWidth <= 768) {
      return <Mobile/>;
    } else {
      return <Computer/>;
    }
  }
}

export default DashBoard;


// WEBPACK FOOTER //
// ./src/scripts/containers/DashBoard/index.js